/* 次回入荷フォーム：「ブラウザ通知」行を隠し、余白・幅・改行をショップの雰囲気に整える。2026-10-06／10-07 登録後メッセージを下に表示／スマホでも横並び */
(function () {
  var PHRASE = 'ブラウザ通知も受け取る';
  var TITLE = '次回入荷のお知らせ';
  var LEAD = '次回の入荷が決まりましたら、メールでお知らせします。';
  var TAIL = '入荷をお約束するものではありません。';
  var BTN = '140px';
  var INP = 'min(230px, calc(100% - ' + BTN + '))';
  var css = '' +
    '.fep-bis{width:fit-content!important;max-width:100%!important;text-align:left!important;padding:22px clamp(16px,4vw,22px)!important;box-sizing:border-box}' +
    '.fep-bis :is(h1,h2,h3,h4,p,div,span,label){text-align:left!important}' +
    '.fep-bis form,.fep-bis :has(>input[type="email"]){display:flex!important;flex-wrap:wrap!important;align-items:center!important;gap:0!important;width:100%!important;max-width:100%!important}' +
    '.fep-bis :has(>input[type="email"])>*:not(input):not(button){flex:0 0 100%!important;order:3!important;width:100%!important;max-width:100%!important;margin:12px 0 0!important;padding:0!important;color:#2b2d29!important;font-size:13px!important;line-height:1.8!important}' +
    '.fep-bis input[type="email"]{flex:0 0 ' + INP + '!important;width:' + INP + '!important;min-width:0!important;max-width:100%!important;box-sizing:border-box!important;height:50px!important;min-height:50px!important;max-height:50px!important;margin:0!important;padding:0 14px!important;font-size:14px;line-height:normal!important;border-radius:0!important;display:block}' +
    '.fep-bis input[type="email"]::placeholder{color:#8a8c85;line-height:normal}' +
    '.fep-bis button{flex:0 0 ' + BTN + '!important;width:' + BTN + '!important;min-width:0!important;box-sizing:border-box!important;height:49px!important;min-height:49px!important;max-height:49px!important;margin:0!important;padding:0 6px!important;font-size:13px;line-height:1!important;letter-spacing:.02em;white-space:nowrap!important;border-radius:0!important;display:flex;align-items:center;justify-content:center}' +
    '.fep-bis-lead{font-size:clamp(11.5px,3.3vw,13.5px)!important;line-height:1.8!important}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function run() {
    document.querySelectorAll('label, span, div, p').forEach(function (el) {
      if (el.children.length > 2 || el.dataset.fepHidden) return;
      if ((el.textContent || '').trim() !== PHRASE) return;
      var box = el.closest('label') || el;
      var wrap = box.parentElement;
      if (wrap && wrap.querySelector('input[type=checkbox]') && (wrap.textContent || '').trim() === PHRASE) box = wrap;
      box.style.setProperty('display', 'none', 'important');
      el.dataset.fepHidden = '1';
    });
    document.querySelectorAll('input[type=email]').forEach(function (inp) {
      if (inp.dataset.fepBis) return;
      var node = inp.parentElement;
      for (var i = 0; node && i < 8; i++, node = node.parentElement) {
        if ((node.textContent || '').indexOf(TITLE) > -1 && (node.textContent || '').length < 400) {
          node.classList.add('fep-bis');
          inp.dataset.fepBis = '1';
          break;
        }
      }
    });
    document.querySelectorAll('.fep-bis *').forEach(function (el) {
      if (el.children.length || el.dataset.fepBr) return;
      var t = (el.textContent || '').trim();
      if (t === LEAD + TAIL) {
        el.textContent = '';
        el.appendChild(document.createTextNode(LEAD));
        el.appendChild(document.createElement('br'));
        el.appendChild(document.createTextNode(TAIL));
        el.classList.add('fep-bis-lead');
        el.dataset.fepBr = '1';
      }
    });
  }
  run();
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();